module.exports = "/packs/images/our-story/hero@2x-28b0ef24f69f727dc2613870e5ca8abc.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/our-story/hero@2x.jpg
// module id = 1788
// module chunks = 0